import { render, staticRenderFns } from "./gradeAddOrEdit.vue?vue&type=template&id=3704ee86&scoped=true"
import script from "./gradeAddOrEdit.vue?vue&type=script&lang=js"
export * from "./gradeAddOrEdit.vue?vue&type=script&lang=js"
import style0 from "./gradeAddOrEdit.vue?vue&type=style&index=0&id=3704ee86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3704ee86",
  null
  
)

export default component.exports